import React from "react";

const About = () => {
  return (
    <div className="center about_page">
      <h3>Rock Paper Scissor Game</h3>
      <h3>version: 2.1.0</h3>
      <h3 className="creator-signature">
        Created by:&nbsp;
        <a href="https://github.com/Sahil-4" target="_blank" rel="noreferrer">
          Sahil-4
        </a>
      </h3>
    </div>
  );
};

export default About;
